const SELECTORS = {
	collapseTrigger: '[data-collapse-trigger]',
	collapseElement: '.collapse__element',
	collapseElementData: 'data-collapse-element',
};

const CLASSES = {
	hidden: 'hidden',
};

export class ElementCollapse {
	constructor() {
		this.collapseTrigger = [...document.querySelectorAll(SELECTORS.collapseTrigger)];
		this.collapseElement = [...document.querySelectorAll(SELECTORS.collapseElement)];

		const requiredElements = [...this.collapseTrigger, ...this.collapseElement];

		if (requiredElements.some((ele) => !ele)) {
			return;
		}

		this.bindEvents();
		this.setup();
	}

	static init() {
		// eslint-disable-next-line
		new ElementCollapse();
	}

	/**
	 * Bind `this` explicitly for event listeners.
	 */
	bindEvents() {
		['onChange'].forEach((e) => {
			this[e] = this[e].bind(this);
		});
	}

	hide() {
		this.collapseElement.forEach((item) => {
			item.classList.add(CLASSES.hidden);
		});
	}

	static show(item) {
		item.classList.remove(CLASSES.hidden);
	}

	onChange(event) {
		const collapseTriggerValue = event.value;

		// hide all elements than set active element
		this.hide();
		this.collapseElement.forEach((item) => {
			if (item.getAttribute(SELECTORS.collapseElementData) === collapseTriggerValue) {
				ElementCollapse.show(item);
			}
		});
	}

	setupEventListeners() {
		this.collapseTrigger.forEach((e) => e.addEventListener('change', () => this.onChange(e)));
	}

	setup() {
		this.setupEventListeners();
	}

	destroy() {
		this.collapseTrigger.forEach((e) => e.removeEventListener('change', () => this.onChange(e)));
	}
}
